module.exports = __webpack_public_path__ + "static/media/vicky.76d6f2e2.jpg";